import React, {Component} from 'react';
import {connect} from 'react-redux';
import StackOptions from './stack-options';
import ChooseTeamsRandomly from './choose-teams-randomly';
import ForceCaptain from './force-captain';
import DisallowedPositions from './disallowed-positions';
import Action from 'components/organisms/random-team-stacking/actions';

class Stack extends Component {
    componentDidMount() {
        this.props.dispatch(Action.set('Teams', this.props.games));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.props.dispatch(Action.set('Teams', this.props.games));
    }

    render() {
        return (
            <div className="white-box">
                <h2>Stack Rules</h2>
                <div className="gap-y">
                    <ChooseTeamsRandomly />
                    <ForceCaptain />
                    <DisallowedPositions />
                    <div className="stack-filter">
                        <StackOptions />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {
            filters: {games},
        },
    } = state;
    return {
        games,
    };
}

export default connect(mapStatesToProps)(Stack);
